import { tv } from "tailwind-variants";

export const menuStyle = tv({
  slots: {
    popover:
      "max-h-60 max-w-xl min-w-(--trigger-width) origin-(--trigger-anchor-point) overflow-hidden rounded-md bg-white text-base shadow-lg ring-1 ring-black/5 transition focus:outline-hidden data-[entering]:scale-95 data-[entering]:opacity-0 data-[entering]:duration-150 data-[exiting]:scale-95 data-[exiting]:opacity-0 data-[exiting]:duration-75 data-[trigger=SubmenuTrigger]:-mt-1 data-[trigger=SubmenuTrigger]:min-w-0 data-[trigger=SubmenuTrigger]:data-[placement=left]:-mr-2 data-[trigger=SubmenuTrigger]:data-[placement=right]:-ml-2 sm:text-sm",
    scrollContainer:
      "max-h-[inherit] overflow-auto rounded-[inherit] bg-white p-1",
    item: "group flex items-center justify-between gap-2 rounded-md px-2 py-1.5 text-foreground select-none hover:bg-muted focus:bg-muted disabled:cursor-not-allowed disabled:text-gray-400 data-[focused]:bg-muted data-[open]:bg-muted selected:font-semibold",
    /** Section label. Shares the item's horizontal padding so both align. */
    sectionHeader: "px-2 py-2 text-xs font-semibold text-muted-foreground",
    itemIcon: "size-5 shrink-0",
  },
});
